import { render, staticRenderFns } from "./CommentsHistory.vue?vue&type=template&id=2d32b396&scoped=true"
import script from "./CommentsHistory.vue?vue&type=script&lang=js"
export * from "./CommentsHistory.vue?vue&type=script&lang=js"
import style0 from "./CommentsHistory.vue?vue&type=style&index=0&id=2d32b396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d32b396",
  null
  
)

export default component.exports